<template>
  <div class="row" :class="customClass">
    <r-switch-button v-for="(option, index) in options" :key="option.value"
                     :select-on="option.value"
                     :value="value"
                     :label="option.label"
                     :default-color="defaultColor"
                     :default-text-color="defaultTextColor"
                     :selected-color="selectedColor"
                     :selected-text-color="selectedTextColor"
                     :size="size"
                     :unelevated="unelevated"
                     :position="position(options.length, index)"
                     v-on="$listeners" />
  </div>
</template>

<script>
import RSwitchButton from '@/components/base/RSwitchButton';

export default {
  name: 'RSwitchButtons',
  components: { RSwitchButton },
  props: {
    options: Array,
    customClass: String,
    value: {
      type: [String, Number],
      required: true,
    },
    lines: {
      type: Number,
      default: 1,
    },
    defaultColor: {
      type: String,
      required: true,
    },
    selectedColor: {
      type: String,
      required: true,
    },
    defaultTextColor: {
      type: String,
      default: 'white',
    },
    selectedTextColor: {
      type: String,
      default: 'white',
    },
    size: {
      type: String,
      default: 'xl',
    },
    unelevated: Boolean,
  },
  methods: {
    position(numberOfOptions, index) {
      if (index === 0) {
        return 'first';
      }
      if (index === numberOfOptions - 1) {
        return 'last';
      }
      return 'middle';
    },
  },
};
</script>
